function bannerDotsPosition() {

	var $sliderText = document.querySelector('.photo-slider__content-container'),
		$sliderDots = document.querySelector('.photo-slider_dots-hld').style,
		sliderTextHeight = $sliderText.offsetHeight,
		sliderTextOffset = $sliderText.offsetTop;

	if($sliderText) {
		$sliderDots.top = sliderTextOffset + sliderTextHeight + 40 +'px';
	}
	
};

module.exports = bannerDotsPosition;